import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TeamStoreService } from '../../services/team-store.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() currentTab: Number;
  @Input() productList: any[] = [];
  @Input() action: any = '';
  @Output() dialogEmit: EventEmitter<any> = new EventEmitter();
  @Output() checkProduct: EventEmitter<any> = new EventEmitter();
  @Output() checkColors: EventEmitter<any> = new EventEmitter();
  @Input() selectedProductList: any[] = [];

  constructor(private teamServ: TeamStoreService, private commonService: CommonService) { }

  ngOnInit() {
    this.restoreSelectedState();
    // this.commonService.postHeightToParent("medium")
    // this.commonService.postHeightToParent("high")
    // this.commonService.postHeightToParent("ultra")
    this.commonService.postIframeHeight();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.productList && this.productList?.length) {
      this.restoreSelectedState();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.restoreSelectedState();
      this.reinitializeDoogmaSafely();
      this.commonService.postIframeHeight();
    }, 0);
  }

  restoreSelectedState(): void {
    this.productList.forEach(product => {
      // ✅ Fallback for selectedColor if not set
      if (!product.selectedColor && product.colorList?.length > 0) {
        const selectedClr = product.colorList.find(c => c.stat);
        if (selectedClr) {
          product.selectedColor = selectedClr.id;
        } else {
          product.colorList[0].stat = true;
          product.selectedColor = product.colorList[0].id;
        }
      }

      // ✅ Restore color stat flags
      if (product.colorList) {
        product.colorList.forEach(color => {
          color.stat = color.id === product.selectedColor;
        });
      }

      // ✅ Restore selectedArt
      if (product.Arts) {
        product.Arts.forEach(art => {
          art.stat = art.artUrl === product.selectedArt;
        });
      }

      console.log('Restored:', product.name, 'Color:', product.selectedColor, 'Art:', product.selectedArt);
    });
  }

  reinitializeDoogmaSafely(): void {
    this.productList.forEach(product => {
      const canvasId = 'canvas' + product.uniqueNumber;

      setTimeout(() => {
        const canvas = document.getElementById(canvasId);
        if (!canvas) {
          console.warn(`Canvas ${canvasId} not yet in DOM — skipping Doogma init.`);
          return;
        }

        try {
          // Replace with real Doogma init
          console.log(`Doogma rendering on canvas: ${canvasId}`);
        } catch (err) {
          console.error('Doogma init error:', err);
        }
      }, 100);
    });
  }

  emitDialog(modStat: any, product: any) {
    this.dialogEmit.emit({ modStat: modStat, product: product });
  }

  scrollLeft(scrollContainer: HTMLDivElement) {
    scrollContainer.scrollLeft -= 100;
  }

  scrollRight(scrollContainer: HTMLDivElement) {
    scrollContainer.scrollLeft += 100;
  }

  emitCheckProduct(product: any, index: any) {
    this.checkProduct.emit({ product: product, i: index });
  }

  isDoogmaRendered(item: any): boolean {
    return item?.hasDoogma;
  }

  getTextColor(hex: string): string {
    if (!hex) return '#000';
    hex = hex.replace(/^#/, '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    let brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128 ? '#fff' : '#000';
  }

  public checkColor(product: any, color: any) {
    product.colorList?.forEach((clr: any) => {
      clr.stat = clr.id === color.id;
    });

    this.teamServ.getProductDetails(product.id).subscribe((data: any) => {
      let imageSources = data.products.variants
        .find((clr: any) => clr.name === color.name)?.images
        ?.map((src: any) => src.src) || [];

      if (data?.products?.variants) {
        const selectedColor = data.products.variants.find(x => x.id === color.id);
        if (selectedColor) {
          const firstSize = selectedColor.sizeVariants[0].size;
          const lastSize = selectedColor.sizeVariants[selectedColor.sizeVariants.length - 1].size;

          product.availableSizes = `${firstSize} - ${lastSize}`;
          product.price = selectedColor.sizeVariants[0].storePrice;
          product.selectedColor = color.id;
        }
      }

      if (imageSources?.length) {
        product.image = imageSources;
      }

      this.checkColors.emit(product);
    });
  }

  cycleDesign(product: any): void {
    if (!product || !product.Arts || product.Arts.length === 0) return;

    const currentIndex = product.Arts.findIndex((art: any) => art.stat);
    const nextIndex = (currentIndex + 1) % product.Arts.length;

    this.emitCheckProduct(product, nextIndex);
  }

  isProductComboAdded(product: any): boolean {
    if (!product?.id || !product?.selectedColor || !product?.selectedArt) return false;

    return this.selectedProductList.some(p =>
      p.id === product.id &&
      p.selectedColor === product.selectedColor &&
      p.selectedArt === product.selectedArt
    );
  }
}
